import React__default from 'react';
import { Icon } from '../Icon/Icon.js';

const getBannerIcon = type => {
  switch (type) {
    case 'success':
      return React__default.createElement(Icon, {
        name: "tick",
        className: "yt-green-solid mt-1 self-start rounded-full"
      });

    case 'error':
      return React__default.createElement(Icon, {
        name: "warning",
        className: "yt-red-solid mt-1 self-start rounded-full"
      });

    case 'warning':
      return React__default.createElement(Icon, {
        name: "warning",
        className: "yt-yellow-solid mt-1 self-start rounded-full"
      });

    case 'information':
      return React__default.createElement(Icon, {
        name: "info",
        className: "yt-blue-solid mt-1 self-start rounded-full"
      });

    default:
      return null;
  }
};

export { getBannerIcon };
//# sourceMappingURL=util.js.map
